/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-gradient-generator block)");
/* eslint-enable no-console */

(function () {
    'use strict';

    const gel = id => document.getElementById(id);

    const ICON_DRAG =
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">' +
        '<circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/>' +
        '<circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/>' +
        '<circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>';

    const ICON_EYE =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">' +
        '<path d="M20.71 5.63l-2.34-2.34a1 1 0 0 0-1.41 0l-3.12 3.12-1.41-1.42-1.42 1.42 1.41 1.41' +
        '-6.6 6.6A2 2 0 0 0 5 16v3h3a2 2 0 0 0 1.42-.59l6.6-6.6 1.41 1.42 1.42-1.42-1.42-1.41' +
        ' 3.12-3.12a1 1 0 0 0 0-1.65zM8 17H7v-1l6.6-6.58 1 1z"/></svg>';

    const PALETTES = [
        { name: 'Sunset', stops: [{ c: '#f97316', p: 0 }, { c: '#ec4899', p: 100 }] },
        { name: 'Ocean', stops: [{ c: '#0ea5e9', p: 0 }, { c: '#6366f1', p: 100 }] },
        { name: 'Aurora', stops: [{ c: '#10b981', p: 0 }, { c: '#3b82f6', p: 50 }, { c: '#8b5cf6', p: 100 }] },
        { name: 'Neon', stops: [{ c: '#ff00ff', p: 0 }, { c: '#00ffff', p: 100 }] },
        { name: 'Peach', stops: [{ c: '#fda085', p: 0 }, { c: '#f6d365', p: 100 }] },
        { name: 'Mint', stops: [{ c: '#84fab0', p: 0 }, { c: '#8fd3f4', p: 100 }] },
        { name: 'Fire', stops: [{ c: '#f83600', p: 0 }, { c: '#f9d423', p: 100 }] },
        { name: 'Purple', stops: [{ c: '#7c3aed', p: 0 }, { c: '#db2777', p: 100 }] },
        { name: 'Pastel', stops: [{ c: '#fbc2eb', p: 0 }, { c: '#a6c1ee', p: 100 }] },
        { name: 'Forest', stops: [{ c: '#134e5e', p: 0 }, { c: '#71b280', p: 100 }] },
        { name: 'Midnight', stops: [{ c: '#232526', p: 0 }, { c: '#414345', p: 100 }] },
        { name: 'Gold', stops: [{ c: '#f7971e', p: 0 }, { c: '#ffd200', p: 100 }] },
        { name: 'Rose', stops: [{ c: '#f43f5e', p: 0 }, { c: '#fb923c', p: 100 }] },
        { name: 'Sky', stops: [{ c: '#e0f2fe', p: 0 }, { c: '#0284c7', p: 100 }] },
        { name: 'Candy', stops: [{ c: '#ff9a9e', p: 0 }, { c: '#fad0c4', p: 50 }, { c: '#ffecd2', p: 100 }] },
        { name: 'Deep Sea', stops: [{ c: '#001f3f', p: 0 }, { c: '#0074d9', p: 100 }] },
        { name: 'Spring', stops: [{ c: '#a8edea', p: 0 }, { c: '#fed6e3', p: 100 }] },
        { name: 'Volcano', stops: [{ c: '#1a1a2e', p: 0 }, { c: '#e94560', p: 100 }] },
        { name: 'Cotton', stops: [{ c: '#fddb92', p: 0 }, { c: '#d1fdff', p: 100 }] },
        { name: 'Twilight', stops: [{ c: '#0f2027', p: 0 }, { c: '#203a43', p: 50 }, { c: '#2c5364', p: 100 }] },
        { name: 'Lemon', stops: [{ c: '#f9f047', p: 0 }, { c: '#0fd850', p: 100 }] },
        { name: 'Blueberry', stops: [{ c: '#4776e6', p: 0 }, { c: '#8e54e9', p: 100 }] },
        { name: 'Coral', stops: [{ c: '#ff6b6b', p: 0 }, { c: '#feca57', p: 100 }] },
        { name: 'Nordic', stops: [{ c: '#3d5a80', p: 0 }, { c: '#98c1d9', p: 50 }, { c: '#e0fbfc', p: 100 }] },
    ];

    const LS_H = 'gg_history', LS_F = 'gg_favorites', MAX_H = 10;
    const lsGet = k => { try { const v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; } catch { return []; } };
    const lsSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { } };

    // ── State ──────────────────────────────────────────────────
    const S = {
        type: 'linear', angle: 90, shape: 'ellipse',
        mode: 'bg', fmt: 'css', gmode: 'smooth', steps: 5, grain: 0,
        stops: [{ color: '#6366f1', pos: 0 }, { color: '#ec4899', pos: 100 }],
        a11y: { btn: '#ffffff', text: '#ffffff' }
    };

    // ── Helpers ────────────────────────────────────────────────
    const sorted = () => S.stops.slice().sort((a, b) => a.pos - b.pos);

    function mixHex(h1, h2, t) {
        const lerp = (a, b) => Math.round(Math.max(0, Math.min(255, a + (b - a) * t)));
        return '#' + [[1, 3], [3, 5], [5, 7]].map(([a, b]) =>
            lerp(parseInt(h1.slice(a, b), 16), parseInt(h2.slice(a, b), 16)).toString(16).padStart(2, '0')
        ).join('');
    }

    function hslToHex(h, s, l) {
        s /= 100; l /= 100;
        const k = n => (n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = n => Math.max(0, Math.min(1, l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));
        return '#' + [f(0), f(8), f(4)].map(v => Math.round(v * 255).toString(16).padStart(2, '0')).join('');
    }

    function interpolateAt(pos) {
        const s = sorted();
        if (pos <= s[0].pos) return s[0].color;
        if (pos >= s[s.length - 1].pos) return s[s.length - 1].color;
        for (let i = 0; i < s.length - 1; i++) {
            if (pos >= s[i].pos && pos <= s[i + 1].pos) {
                const t = (pos - s[i].pos) / Math.max(0.001, s[i + 1].pos - s[i].pos);
                return mixHex(s[i].color, s[i + 1].color, t);
            }
        }
        return s[0].color;
    }

    // ── Gradient builders ──────────────────────────────────────
    function stopsStr(arr) { return arr.map(s => `${s.color} ${s.pos}%`).join(', '); }

    function buildSmoothGrad() {
        const str = stopsStr(sorted());
        if (S.type === 'linear') return `linear-gradient(${S.angle}deg, ${str})`;
        if (S.type === 'radial') return `radial-gradient(${S.shape} at center, ${str})`;
        return `conic-gradient(from ${S.angle}deg, ${str})`;
    }

    function buildStepGrad() {
        const n = Math.max(2, S.steps);
        const stepStops = [];
        for (let i = 0; i < n; i++) {
            const p0 = Math.round(i / n * 100), p1 = Math.round((i + 1) / n * 100);
            const c = interpolateAt(Math.round((p0 + p1) / 2));
            stepStops.push(`${c} ${p0}%`, `${c} ${p1}%`);
        }
        const str = stepStops.join(', ');
        if (S.type === 'linear') return `linear-gradient(${S.angle}deg, ${str})`;
        if (S.type === 'radial') return `radial-gradient(${S.shape} at center, ${str})`;
        return `conic-gradient(from ${S.angle}deg, ${str})`;
    }

    const buildGradient = () => S.gmode === 'steps' ? buildStepGrad() : buildSmoothGrad();

    // ── Render ─────────────────────────────────────────────────
    const previewBtn = gel('previewBtn'), previewText = gel('previewText'), previewTextWrap = gel('previewTextWrap');
    const cssOutput = gel('cssOutput');
    let _renderTimer = null, _lastGrad = '';

    function render(skipHistory) {
        const grad = buildGradient();
        gel('previewBg').style.background = grad;
        previewBtn.style.background = grad;
        gel('previewCardHeader').style.background = grad;
        previewText.style.backgroundImage = grad;

        const op = S.grain / 100;
        ['noiseBg', 'noiseBtn', 'noiseCard', 'noiseText'].forEach(id => { gel(id).style.opacity = op; });

        cssOutput.value = formatters[S.fmt]();
        const hint = formatHints[S.fmt];
        gel('formatHint').textContent = hint || '';
        gel('formatHint').classList.toggle('hidden', !hint);

        if (grad !== _lastGrad) {
            renderGradBar();
            // Fix 3 : worstCR uniquement si A11Y visible ET gradient changé
            if (S.mode === 'btn' || S.mode === 'text') updateA11y();
            _lastGrad = grad;
        }

        renderSwatches();
        gel('shareUrl').value = location.origin + location.pathname;

        if (!skipHistory) {
            clearTimeout(_renderTimer);
            _renderTimer = setTimeout(pushHistory, 600);
        }
    }

    // ── Gradient bar ───────────────────────────────────────────
    const gradBarWrap = gel('gradBarWrap'), gradBar = gel('gradBar');

    function renderGradBar() {
        gradBar.style.background = `linear-gradient(to right, ${stopsStr(sorted())})`;
        gradBarWrap.querySelectorAll('.stop-handle').forEach(h => h.remove());

        S.stops.forEach((stop, i) => {
            const h = document.createElement('div');
            h.className = 'stop-handle';
            // Fix 5 : clamp entre 0.8% et 99.2% pour éviter le débordement
            const clampedPos = Math.min(99.2, Math.max(0.8, stop.pos));
            h.style.cssText = `left:${clampedPos}%;background:${stop.color}`;
            h.title = `${stop.color} — ${stop.pos}%`;

            const onMove = e => {
                const rect = gradBarWrap.getBoundingClientRect();
                const clientX = e.touches ? e.touches[0].clientX : e.clientX;
                const pct = Math.round(Math.min(100, Math.max(0, (clientX - rect.left) / rect.width * 100)));
                if (stop.pos === pct) return;
                stop.pos = pct;
                const cp = Math.min(99.2, Math.max(0.8, pct));
                h.style.left = cp + '%';
                h.title = `${stop.color} — ${pct}%`;
                const row = colorsList.querySelector(`[data-index="${i}"]`);
                if (row) { row.querySelector('[type="range"]').value = pct; row.querySelector('.color-pos').textContent = pct + '%'; }
                const g = buildGradient();
                gel('previewBg').style.background = g;
                previewBtn.style.background = g;
                gel('previewCardHeader').style.background = g;
                previewText.style.backgroundImage = g;
                gradBar.style.background = `linear-gradient(to right, ${stopsStr(sorted())})`;
            };

            const onUp = () => {
                render(false);
                document.removeEventListener('mousemove', onMove);
                document.removeEventListener('mouseup', onUp);
                document.removeEventListener('touchmove', onMove);
                document.removeEventListener('touchend', onUp);
            };

            h.addEventListener('mousedown', e => {
                e.stopPropagation();
                document.addEventListener('mousemove', onMove);
                document.addEventListener('mouseup', onUp);
            });
            h.addEventListener('touchstart', e => {
                e.stopPropagation();
                document.addEventListener('touchmove', onMove, { passive: true });
                document.addEventListener('touchend', onUp);
            }, { passive: true });

            gradBarWrap.appendChild(h);
        });
    }

    gradBarWrap.addEventListener('click', e => {
        if (e.target.classList.contains('stop-handle')) return;
        const rect = gradBarWrap.getBoundingClientRect();
        const pos = Math.round((e.clientX - rect.left) / rect.width * 100);
        S.stops.push({ color: interpolateAt(pos), pos });
        colorsList.innerHTML = '';
        S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
        render();
    });

    // ── Swatches — Fix 2 : cache key ──────────────────────────
    function renderSwatches() {
        const key = S.gmode + '|' + S.steps + '|' + S.stops.map(s => s.color + s.pos).join(',');
        if (renderSwatches._key === key) return;
        renderSwatches._key = key;

        const wrap = gel('swatchesWrap');
        wrap.innerHTML = '';
        let colors = [];

        if (S.gmode === 'steps') {
            const n = Math.max(2, S.steps);
            for (let i = 0; i < n; i++) {
                const pos = Math.round((i + 0.5) / n * 100);
                colors.push({ color: interpolateAt(pos), label: `Step ${i + 1}` });
            }
            gel('swatchesTitle').textContent = `Step colors (${n}) — click to copy`;
        } else {
            for (let i = 0; i <= 12; i++) {
                const pos = Math.round(i / 12 * 100);
                colors.push({ color: interpolateAt(pos), label: `${pos}%` });
            }
            gel('swatchesTitle').textContent = 'Interpolated swatches — click to copy';
        }

        colors.forEach(({ color, label }) => {
            const sw = document.createElement('div');
            sw.className = 'swatch'; sw.style.background = color; sw.title = `${color} (${label})`;
            sw.addEventListener('click', () => {
                navigator.clipboard.writeText(color).then(() => showToast(`Copied ${color}`));
            });
            wrap.appendChild(sw);
        });
    }

    // ── Code formatters ────────────────────────────────────────
    function twDir() {
        const D = { 0: 'to-t', 45: 'to-tr', 90: 'to-r', 135: 'to-br', 180: 'to-b', 225: 'to-bl', 270: 'to-l', 315: 'to-tl' };
        return D[Object.keys(D).reduce((a, b) => Math.abs(b - S.angle) < Math.abs(a - S.angle) ? b : a)];
    }

    const formatters = {
        css: () => `background: ${buildGradient()};`,
        'css-prefix': () => {
            const str = stopsStr(sorted());
            if (S.type === 'linear') return [
                `-webkit-linear-gradient(${S.angle}deg, ${str})`,
                `-moz-linear-gradient(${S.angle}deg, ${str})`,
                buildGradient()
            ].map(v => `background: ${v};`).join('\n');
            if (S.type === 'radial') return [
                `-webkit-radial-gradient(${S.shape} at center, ${str})`,
                buildGradient()
            ].map(v => `background: ${v};`).join('\n');
            return `background: ${buildGradient()};`;
        },
        tailwind: () => {
            const s = sorted();
            if (S.type !== 'linear') return `/* Tailwind only supports linear gradients natively */\nbackground: ${buildGradient()};`;
            const cls = [`bg-gradient-${twDir()}`, `from-[${s[0].color}]`, ...s.slice(1, -1).map(x => `via-[${x.color}]`), `to-[${s[s.length - 1].color}]`].join(' ');
            return `class="${cls}"`;
        },
        scss: () => {
            const s = sorted();
            const vars = s.map((x, i) => `$c${i + 1}: ${x.color};`).join('\n') + `\n$angle: ${S.angle}deg;`;
            const g = S.type === 'linear' ? `linear-gradient($angle, ${stopsStr(s)})`
                : S.type === 'radial' ? `radial-gradient(${S.shape} at center, ${stopsStr(s)})`
                    : `conic-gradient(from $angle, ${stopsStr(s)})`;
            return `${vars}\n\n.gradient {\n  background: ${g};\n}`;
        },
        json: () => JSON.stringify({
            type: S.type, angle: S.angle, shape: S.shape, mode: S.gmode, steps: S.steps, grain: S.grain,
            stops: sorted().map(s => ({ color: s.color, position: `${s.pos}%` })),
            css: `background: ${buildGradient()};`
        }, null, 2)
    };

    const formatHints = {
        css: null,
        'css-prefix': '⚠️ Vendor prefixes are only needed for very old browsers (pre-2015).',
        tailwind: '💡 Requires Tailwind CSS v3+ with JIT mode for arbitrary values.',
        scss: '💡 Variables are auto-generated. Paste into any .scss file.',
        json: '💡 Useful for storing gradients in a database or passing via API.'
    };

    // ── History & Favorites ────────────────────────────────────
    function snapshot(label) {
        return {
            id: Date.now(), label: label || null, type: S.type, angle: S.angle, shape: S.shape,
            gmode: S.gmode, steps: S.steps, grain: S.grain,
            stops: S.stops.map(s => ({ ...s })), css: `background: ${buildGradient()};`, ts: Date.now()
        };
    }

    function pushHistory() {
        const h = lsGet(LS_H), snap = snapshot();
        if (h.length && h[0].css === snap.css) return;
        h.unshift(snap); if (h.length > MAX_H) h.length = MAX_H;
        lsSet(LS_H, h); renderHistory();
    }

    function applySnap(snap) {
        S.type = snap.type; S.angle = snap.angle; S.shape = snap.shape;
        if (snap.gmode) S.gmode = snap.gmode;
        if (snap.steps) S.steps = snap.steps;
        if (typeof snap.grain === 'number') S.grain = snap.grain;
        S.stops = snap.stops.map(s => ({ ...s }));
        syncControls();
        colorsList.innerHTML = '';
        S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
        render(true);
    }

    function syncControls() {
        gel('gradType').value = S.type;
        gel('angleRange').value = S.angle; gel('angleNum').value = S.angle;
        gel('radialShape').value = S.shape;
        gel('gradMode').value = S.gmode;
        gel('stepsNum').value = S.steps;
        gel('grainRange').value = S.grain; gel('grainVal').textContent = S.grain + '%';
        gel('angleLabel').classList.toggle('hidden', S.type === 'radial');
        gel('radialShapeLabel').classList.toggle('hidden', S.type !== 'radial');
        gel('stepsLabel').classList.toggle('hidden', S.gmode !== 'steps');
    }

    function renderHistory() {
        const list = gel('historyList'), h = lsGet(LS_H);
        list.innerHTML = '';
        if (!h.length) { list.innerHTML = '<div class="saved-empty">No history yet — gradients are saved automatically.</div>'; return; }
        h.forEach((snap, idx) => {
            const grad = `linear-gradient(to right, ${snap.stops.map(s => `${s.color} ${s.pos}%`).join(', ')})`;
            const time = new Date(snap.ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const item = mkSavedItem(grad, `${snap.type} · ${snap.angle}° · ${snap.stops.length} stops · ${time}`, snap.css, [
                { txt: 'Apply', action: () => { applySnap(snap); showToast('Applied'); } },
                { txt: '✕', cls: 'del', action: () => { const hh = lsGet(LS_H); hh.splice(idx, 1); lsSet(LS_H, hh); renderHistory(); } }
            ]);
            list.appendChild(item);
        });
    }

    function renderFavorites() {
        const list = gel('favoritesList'), favs = lsGet(LS_F);
        list.innerHTML = '';
        if (!favs.length) { list.innerHTML = '<div class="saved-empty">No favorites yet — click ☆ Favorite to pin a gradient.</div>'; return; }
        favs.forEach((snap, idx) => {
            const grad = `linear-gradient(to right, ${snap.stops.map(s => `${s.color} ${s.pos}%`).join(', ')})`;
            const item = mkSavedItem(grad, snap.label || 'My gradient', snap.css, [
                { txt: 'Apply', action: () => { applySnap(snap); showToast(`"${snap.label || 'Favorite'}" applied`); } },
                { txt: '✏️', action: () => { startRename(item, idx); } },
                { txt: '✕', cls: 'del', action: () => { const f = lsGet(LS_F); f.splice(idx, 1); lsSet(LS_F, f); renderFavorites(); showToast('Removed'); } }
            ]);
            list.appendChild(item);
        });
    }

    function mkSavedItem(grad, name, css, btns) {
        const item = document.createElement('div'); item.className = 'saved-item';
        const thumb = document.createElement('div'); thumb.className = 'saved-thumb'; thumb.style.background = grad;
        const meta = document.createElement('div'); meta.className = 'saved-meta';
        const nameEl = document.createElement('div'); nameEl.className = 'saved-name'; nameEl.textContent = name;
        const cssEl = document.createElement('div'); cssEl.className = 'saved-css'; cssEl.textContent = css.slice(0, 60) + '…';
        meta.append(nameEl, cssEl);
        const acts = document.createElement('div'); acts.className = 'saved-actions';
        btns.forEach(b => {
            const btn = document.createElement('button'); btn.className = 'saved-btn' + (b.cls ? ' ' + b.cls : '');
            btn.textContent = b.txt; btn.addEventListener('click', b.action); acts.appendChild(btn);
        });
        item.append(thumb, meta, acts);
        thumb.addEventListener('click', btns[0].action);
        return item;
    }

    function startRename(item, idx) {
        const nameEl = item.querySelector('.saved-name'), cur = nameEl.textContent;
        nameEl.innerHTML = `<input class="saved-name-input" value="${cur.replace(/"/g, '&quot;')}" maxlength="40">`;
        const inp = nameEl.querySelector('input'); inp.focus(); inp.select();
        const save = () => {
            const v = inp.value.trim() || cur;
            const f = lsGet(LS_F); if (f[idx]) f[idx].label = v; lsSet(LS_F, f);
            nameEl.textContent = v; showToast('Renamed');
        };
        inp.addEventListener('blur', save);
        inp.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); save(); } });
    }

    function saveToFavorites() {
        const name = prompt('Name for this gradient:', `Gradient ${new Date().toLocaleDateString()}`);
        if (name === null) return;
        const snap = snapshot(name.trim() || 'My gradient');
        const f = lsGet(LS_F); f.unshift(snap); lsSet(LS_F, f);
        renderFavorites(); showToast(`Saved as "${snap.label}"`);
        document.querySelectorAll('.subsection-tabs button').forEach(b => b.classList.remove('active'));
        document.querySelector('.subsection-tabs button[data-panel="favorites"]').classList.add('active');
        gel('historyPanel').classList.add('hidden'); gel('favoritesPanel').classList.remove('hidden');
    }

    // ── Color rows — Fix 1 : rebuild ciblé ────────────────────
    const colorsList = gel('colorsList');

    function buildColorRow(i) {
        const stop = S.stops[i];
        const row = document.createElement('div');
        row.className = 'color-row'; row.dataset.index = i; row.draggable = false;
        const hexVal = stop.color.length === 4
            ? stop.color.slice(1).split('').map(x => x + x).join('')
            : stop.color.slice(1).toUpperCase().padStart(6, '0');
        row.innerHTML =
            `<span class="drag-handle">${ICON_DRAG}</span>` +
            `<input type="color" value="${stop.color}">` +
            ('EyeDropper' in window ? `<button class="btn-icon" data-action="eye">${ICON_EYE}</button>` : '') +
            `<input type="text" class="color-hex" value="${hexVal}" maxlength="6">` +
            `<input type="range" min="0" max="100" value="${stop.pos}">` +
            `<span class="color-pos">${stop.pos}%</span>` +
            `<button class="btn-icon btn-remove" data-action="remove">×</button>`;

        row.querySelector('.drag-handle').addEventListener('mousedown', () => { row.draggable = true; });
        row.addEventListener('dragstart', e => {
            if (!row.draggable) { e.preventDefault(); return; }
            e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(i));
            setTimeout(() => row.classList.add('dragging'), 0);
        });
        row.addEventListener('dragend', () => {
            row.draggable = false; row.classList.remove('dragging');
            colorsList.querySelectorAll('.color-row').forEach(r => r.classList.remove('drag-over'));
        });
        row.addEventListener('dragover', e => {
            e.preventDefault();
            colorsList.querySelectorAll('.color-row').forEach(r => r.classList.remove('drag-over'));
            row.classList.add('drag-over');
        });
        row.addEventListener('drop', e => {
            e.preventDefault();
            const from = parseInt(e.dataTransfer.getData('text/plain'), 10);
            if (from === i) return;
            S.stops.splice(i, 0, S.stops.splice(from, 1)[0]);
            colorsList.innerHTML = '';
            S.stops.forEach((_, j) => colorsList.appendChild(buildColorRow(j)));
            render();
        });
        return row;
    }

    function renderColors() {
        const existing = colorsList.querySelectorAll('.color-row');
        if (existing.length !== S.stops.length) {
            colorsList.innerHTML = '';
            S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
            return;
        }
        S.stops.forEach((stop, i) => {
            const row = existing[i];
            row.dataset.index = i;
            const hexVal = stop.color.length === 4
                ? stop.color.slice(1).split('').map(x => x + x).join('')
                : stop.color.slice(1).toUpperCase().padStart(6, '0');
            row.querySelector('[type="color"]').value = stop.color;
            row.querySelector('.color-hex').value = hexVal;
            row.querySelector('[type="range"]').value = stop.pos;
            row.querySelector('.color-pos').textContent = stop.pos + '%';
        });
    }

    colorsList.addEventListener('input', e => {
        const row = e.target.closest('.color-row'); if (!row) return;
        const i = parseInt(row.dataset.index, 10);
        const ci = row.querySelector('[type="color"]'), hi = row.querySelector('.color-hex'), pl = row.querySelector('.color-pos');
        if (e.target === ci) {
            S.stops[i].color = ci.value; hi.value = ci.value.slice(1).toUpperCase(); hi.classList.remove('invalid'); render();
        } else if (e.target === hi) {
            const raw = hi.value.replace(/[^0-9a-fA-F]/g, ''); hi.value = raw.toUpperCase();
            if (raw.length === 6 || raw.length === 3) {
                S.stops[i].color = '#' + raw;
                ci.value = '#' + (raw.length === 3 ? raw.split('').map(x => x + x).join('') : raw);
                hi.classList.remove('invalid'); render();
            } else { hi.classList.toggle('invalid', raw.length > 0); }
        } else if (e.target.type === 'range') {
            S.stops[i].pos = parseInt(e.target.value, 10); pl.textContent = S.stops[i].pos + '%'; render();
        }
    });

    colorsList.addEventListener('blur', e => {
        if (e.target.classList.contains('color-hex') && e.target.classList.contains('invalid')) {
            const i = parseInt(e.target.closest('.color-row').dataset.index, 10);
            e.target.value = S.stops[i].color.slice(1).toUpperCase(); e.target.classList.remove('invalid');
        }
    }, true);

    colorsList.addEventListener('paste', e => {
        if (!e.target.classList.contains('color-hex')) return;
        e.preventDefault();
        const p = (e.clipboardData || window.clipboardData).getData('text').replace('#', '').replace(/[^0-9a-fA-F]/g, '').slice(0, 6).toUpperCase();
        e.target.value = p; e.target.dispatchEvent(new Event('input', { bubbles: true }));
    });

    colorsList.addEventListener('click', e => {
        const btn = e.target.closest('[data-action]'); if (!btn) return;
        const i = parseInt(btn.closest('.color-row').dataset.index, 10);
        if (btn.dataset.action === 'remove') {
            if (S.stops.length <= 2) return;
            S.stops.splice(i, 1);
            colorsList.innerHTML = '';
            S.stops.forEach((_, j) => colorsList.appendChild(buildColorRow(j)));
            render();
        } else if (btn.dataset.action === 'eye') {
            new EyeDropper().open().then(r => { S.stops[i].color = r.sRGBHex; renderColors(); render(); }).catch(() => { });
        }
    });

    // ── Controls ───────────────────────────────────────────────
    gel('gradType').addEventListener('change', e => {
        S.type = e.target.value;
        gel('angleLabel').classList.toggle('hidden', S.type === 'radial');
        gel('radialShapeLabel').classList.toggle('hidden', S.type !== 'radial');
        render();
    });
    gel('radialShape').addEventListener('change', e => { S.shape = e.target.value; render(); });
    gel('angleRange').addEventListener('input', e => { S.angle = parseInt(e.target.value, 10); gel('angleNum').value = S.angle; render(); });
    gel('angleNum').addEventListener('input', e => {
        const v = parseInt(e.target.value, 10);
        S.angle = isNaN(v) ? 0 : Math.min(360, Math.max(0, v));
        gel('angleRange').value = S.angle; render();
    });
    gel('gradMode').addEventListener('change', e => {
        S.gmode = e.target.value; gel('stepsLabel').classList.toggle('hidden', S.gmode !== 'steps');
        renderSwatches._key = null; render();
    });
    gel('stepsNum').addEventListener('input', e => {
        const v = parseInt(e.target.value, 10); S.steps = isNaN(v) ? 5 : Math.min(20, Math.max(2, v));
        renderSwatches._key = null; render();
    });
    gel('grainRange').addEventListener('input', e => {
        S.grain = parseInt(e.target.value, 10); gel('grainVal').textContent = S.grain + '%'; render(true);
    });

    gel('btnAdd').addEventListener('click', () => {
        S.stops.push({ color: interpolateAt(50), pos: 50 });
        colorsList.innerHTML = '';
        S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
        render();
    });
    gel('btnRandomize').addEventListener('click', () => {
        const modes = ['complementary', 'analogous', 'triadic', 'split'];
        const mode = modes[Math.floor(Math.random() * modes.length)];
        const h = Math.floor(Math.random() * 360), s = 65 + Math.floor(Math.random() * 25), l = 45 + Math.floor(Math.random() * 20);
        const map = { complementary: [h, (h + 180) % 360], analogous: [h, (h + 30) % 360, (h + 60) % 360], triadic: [h, (h + 120) % 360, (h + 240) % 360], split: [h, (h + 150) % 360, (h + 210) % 360] };
        S.stops = map[mode].map((hue, i, a) => ({ color: hslToHex(hue, s, l), pos: Math.round(i / (a.length - 1) * 100) }));
        colorsList.innerHTML = '';
        S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
        render(); showToast(`Randomized (${mode})`);
    });
    gel('btnReverse').addEventListener('click', () => {
        S.stops = S.stops.map(s => ({ color: s.color, pos: 100 - s.pos }));
        renderColors(); render();
    });
    gel('btnDistribute').addEventListener('click', () => {
        const n = S.stops.length; if (n < 2) return;
        const s = sorted(); s.forEach((x, i) => x.pos = Math.round(i / (n - 1) * 100)); S.stops = s;
        renderColors(); render(); showToast('Distributed evenly');
    });
    gel('btnSaveFav').addEventListener('click', saveToFavorites);

    document.querySelectorAll('.subsection-tabs button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.subsection-tabs button').forEach(b => b.classList.remove('active')); btn.classList.add('active');
            gel('historyPanel').classList.toggle('hidden', btn.dataset.panel !== 'history');
            gel('favoritesPanel').classList.toggle('hidden', btn.dataset.panel !== 'favorites');
        });
    });

    // Fix 4 : preview tabs sans bloc mort
    document.querySelectorAll('.preview-tabs button').forEach(btn => {
        btn.addEventListener('click', () => {
            if (btn.dataset.mode === 'full') { openFullscreen(); return; }
            document.querySelectorAll('.preview-tabs button').forEach(b => b.classList.remove('active')); btn.classList.add('active');
            S.mode = btn.dataset.mode;
            gel('previewBg').classList.toggle('active', S.mode === 'bg');
            gel('previewBtnWrap').classList.toggle('active', S.mode === 'btn');
            gel('previewCardWrap').classList.toggle('active', S.mode === 'card');
            gel('previewTextWrap').classList.toggle('active', S.mode === 'text');
            gel('textEditWrap').classList.toggle('hidden', S.mode !== 'text');
            updateA11yVisibility(S.mode);
        });
    });

    function openFullscreen() {
        const ov = document.createElement('div');
        ov.style.cssText = 'position:fixed;inset:0;z-index:9999;background:' + buildGradient() + ';cursor:pointer;';
        const cb = document.createElement('button');
        cb.textContent = '✕';
        cb.style.cssText = 'position:absolute;top:20px;right:24px;background:rgba(0,0,0,.55);color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:18px;cursor:pointer;';
        const close = () => { if (document.body.contains(ov)) document.body.removeChild(ov); };
        cb.addEventListener('click', e => { e.stopPropagation(); close(); });
        ov.addEventListener('click', close);
        document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
        ov.appendChild(cb); document.body.appendChild(ov);
    }

    gel('textEditInput').addEventListener('input', e => { previewText.textContent = e.target.value || 'Gradient Text'; });

    document.querySelectorAll('#formatTabs button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('#formatTabs button').forEach(b => b.classList.remove('active')); btn.classList.add('active');
            S.fmt = btn.dataset.fmt; render(true);
        });
    });

    // ── Palettes ───────────────────────────────────────────────
    function renderPalettes() {
        const grid = gel('palettesGrid'); grid.innerHTML = '';
        PALETTES.forEach(p => {
            const el = document.createElement('div'); el.className = 'palette-item';
            el.style.background = `linear-gradient(to right, ${p.stops.map(s => `${s.c} ${s.p}%`).join(', ')})`;
            el.title = p.name; el.innerHTML = `<span>${p.name}</span>`;
            el.addEventListener('click', () => {
                S.stops = p.stops.map(s => ({ color: s.c, pos: s.p }));
                colorsList.innerHTML = '';
                S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
                render(); showToast(`"${p.name}" applied`);
            });
            grid.appendChild(el);
        });
    }

    // ── Share ──────────────────────────────────────────────────
    gel('btnCopyUrl').addEventListener('click', () => {
        navigator.clipboard.writeText(location.origin + location.pathname).then(() => showToast('URL copied!'));
    });

    // ── Copy code ──────────────────────────────────────────────
    gel('btnCopy').addEventListener('click', () => {
        navigator.clipboard.writeText(cssOutput.value).then(() => {
            const b = gel('btnCopy'); b.classList.add('ok'); b.textContent = '✓';
            showToast('Copied!'); setTimeout(() => { b.classList.remove('ok'); b.textContent = 'Copy'; }, 2000);
        });
    });

    // ── A11Y ───────────────────────────────────────────────────
    const isHex = h => /^#[0-9a-fA-F]{6}$/.test(h);
    const lum = hex => [hex.slice(1, 3), hex.slice(3, 5), hex.slice(5, 7)].map(v => { const c = parseInt(v, 16) / 255; return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4; }).reduce((s, v, i) => s + v * [0.2126, 0.7152, 0.0722][i], 0);
    const cr = (a, b) => { const la = lum(a), lb = lum(b); return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05); };
    const wcag = r => r >= 7 ? { l: 'AAA', i: '✅', c: '#1a7a3a', d: 'Excellent' } : r >= 4.5 ? { l: 'AA', i: '✅', c: '#1a7a3a', d: 'Sufficient' } : r >= 3 ? { l: 'AA Large', i: '⚠️', c: '#7a4a00', d: 'Large text only' } : { l: 'Fail', i: '❌', c: '#c00', d: 'Insufficient' };

    function worstCR(solid) {
        const s = sorted();
        const cols = [...s.map(x => x.color), ...s.slice(0, -1).map((x, i) => mixHex(x.color, s[i + 1].color, 0.5))];
        return Math.min(...cols.map(c => cr(c, solid)));
    }

    function updateA11y() {
        const solid = gel('a11yColor').value; if (!isHex(solid)) return;
        const ratio = worstCR(solid), lv = wcag(ratio);
        gel('a11yResult').innerHTML =
            `<span style="font-size:20px">${lv.i}</span>` +
            `<span style="font-weight:700;color:${lv.c};font-size:15px">${lv.l}</span>` +
            `<span style="color:#333;font-size:13px">${ratio.toFixed(2)}:1 — ${lv.d}</span>`;
        if (S.mode === 'btn') { previewBtn.style.color = solid; previewBtn.style.textShadow = 'none'; }
        else { previewTextWrap.style.background = solid; }
    }

    function updateA11yVisibility(mode) {
        if (mode === 'btn' || mode === 'text') {
            gel('a11yWrap').classList.remove('hidden');
            gel('a11yColorLabel').textContent = mode === 'btn' ? 'Button text color' : 'Background color';
            const v = S.a11y[mode]; gel('a11yColor').value = v; gel('a11yHex').value = v.slice(1).toUpperCase();
            updateA11y();
        } else {
            gel('a11yWrap').classList.add('hidden');
            previewBtn.style.color = '#fff'; previewBtn.style.textShadow = '0 1px 3px rgba(0,0,0,.2)';
            previewTextWrap.style.background = '#fff';
        }
    }

    function onA11y(hex) {
        if (!isHex(hex)) return;
        gel('a11yColor').value = hex; gel('a11yHex').value = hex.slice(1).toUpperCase();
        S.a11y[S.mode] = hex; updateA11y();
    }
    gel('a11yColor').addEventListener('input', e => onA11y(e.target.value));
    gel('a11yHex').addEventListener('input', e => {
        const r = e.target.value.replace(/[^0-9a-fA-F]/g, '').toUpperCase(); e.target.value = r;
        if (r.length === 6) onA11y('#' + r);
    });
    gel('a11yHex').addEventListener('paste', e => {
        e.preventDefault();
        const p = (e.clipboardData || window.clipboardData).getData('text').replace('#', '').replace(/[^0-9a-fA-F]/g, '').slice(0, 6).toUpperCase();
        e.target.value = p; e.target.dispatchEvent(new Event('input'));
    });

    // ── Export ─────────────────────────────────────────────────
    const dims = () => {
        if (gel('exportSize').value === 'custom') return [parseInt(gel('customW').value, 10) || 800, parseInt(gel('customH').value, 10) || 600];
        return gel('exportSize').value.split('x').map(Number);
    };
    const fb = (btn, orig) => { btn.textContent = '✓'; setTimeout(() => btn.textContent = orig, 2000); };
    const dl = (href, name) => Object.assign(document.createElement('a'), { href, download: name }).click();
    const h2rgb = hex => [parseInt(hex.slice(1, 3), 16) / 255, parseInt(hex.slice(3, 5), 16) / 255, parseInt(hex.slice(5, 7), 16) / 255];

    gel('exportSize').addEventListener('change', () => gel('customSizeWrap').classList.toggle('hidden', gel('exportSize').value !== 'custom'));

    function drawToCanvas(w, h) {
        const canvas = gel('exportCanvas'), ctx = canvas.getContext('2d');
        canvas.width = w; canvas.height = h;
        const s = sorted(); let cg;
        if (S.type === 'radial') {
            cg = ctx.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, Math.max(w, h) / 2);
        } else {
            const r = (S.angle - 90) * Math.PI / 180, len = Math.sqrt(w * w + h * h) / 2;
            cg = ctx.createLinearGradient(w / 2 - Math.cos(r) * len, h / 2 - Math.sin(r) * len, w / 2 + Math.cos(r) * len, h / 2 + Math.sin(r) * len);
        }
        if (S.gmode === 'steps') {
            const n = S.steps;
            for (let i = 0; i < n; i++) { const c = interpolateAt(Math.round((i + .5) / n * 100)); cg.addColorStop(i / n, c); cg.addColorStop((i + 1) / n - 0.001, c); }
        } else { s.forEach(x => cg.addColorStop(x.pos / 100, x.color)); }
        ctx.fillStyle = cg; ctx.fillRect(0, 0, w, h);
        if (S.grain > 0) {
            const id = ctx.getImageData(0, 0, w, h);
            for (let i = 0; i < id.data.length; i += 4) {
                const n = (Math.random() - .5) * 2 * S.grain * 2.55;
                id.data[i] = Math.max(0, Math.min(255, id.data[i] + n));
                id.data[i + 1] = Math.max(0, Math.min(255, id.data[i + 1] + n));
                id.data[i + 2] = Math.max(0, Math.min(255, id.data[i + 2] + n));
            }
            ctx.putImageData(id, 0, 0);
        }
        return canvas;
    }

    gel('btnPNG').addEventListener('click', () => { const [w, h] = dims(), btn = gel('btnPNG'); dl(drawToCanvas(w, h).toDataURL('image/png'), `gradient-${w}x${h}.png`); fb(btn, '⬇ PNG'); });
    gel('btnWebP').addEventListener('click', () => { const [w, h] = dims(), btn = gel('btnWebP'); dl(drawToCanvas(w, h).toDataURL('image/webp', .92), `gradient-${w}x${h}.webp`); fb(btn, '⬇ WebP'); });
    gel('btnJPEG').addEventListener('click', () => { const [w, h] = dims(), btn = gel('btnJPEG'); dl(drawToCanvas(w, h).toDataURL('image/jpeg', .92), `gradient-${w}x${h}.jpg`); fb(btn, '⬇ JPEG'); });

    gel('btnSVG').addEventListener('click', () => {
        const [w, h] = dims(), btn = gel('btnSVG'), s = sorted();
        const ss = s.map(x => `<stop offset="${x.pos}%" stop-color="${x.color}"/>`).join('');
        let gd;
        if (S.type === 'radial') { gd = `<radialGradient id="g" cx="50%" cy="50%" r="50%">${ss}</radialGradient>`; }
        else { const r = (S.angle - 90) * Math.PI / 180, x1 = Math.round((.5 - Math.cos(r) * .5) * 100), y1 = Math.round((.5 - Math.sin(r) * .5) * 100), x2 = Math.round((.5 + Math.cos(r) * .5) * 100), y2 = Math.round((.5 + Math.sin(r) * .5) * 100); gd = `<linearGradient id="g" x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%">${ss}</linearGradient>`; }
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}"><defs>${gd}</defs><rect width="${w}" height="${h}" fill="url(#g)"/></svg>`;
        const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
        dl(url, `gradient-${w}x${h}.svg`); URL.revokeObjectURL(url); fb(btn, '⬇ SVG');
    });

    let glProg = null, glCvs = null;
    function initGL(n) {
        glCvs = document.createElement('canvas');
        const gl = glCvs.getContext('webgl'); if (!gl) return null;
        let decl = '', mix = '';
        for (let i = 0; i < n; i++) decl += `uniform vec3 u_c${i};uniform float u_p${i};`;
        for (let i = 0; i < n - 1; i++) mix += `if(t>=u_p${i}&&t<=u_p${i + 1}){float f=clamp((t-u_p${i})/max(u_p${i + 1}-u_p${i},.0001),0.,1.);color=mix(u_c${i},u_c${i + 1},f);}`;
        const vs = 'attribute vec2 a;void main(){gl_Position=vec4(a,0,1);}';
        const fs = 'precision mediump float;uniform vec2 u_r;uniform float u_a;uniform int u_t;' + decl + 'void main(){vec2 uv=gl_FragCoord.xy/u_r;float t=0.;if(u_t==0){float r=(u_a-90.)*3.14159/180.;t=clamp(dot(uv-.5,vec2(cos(r),sin(r)))+.5,0.,1.);}else if(u_t==1){t=clamp(distance(uv,vec2(.5))*2.,0.,1.);}else{float r=(u_a-90.)*3.14159/180.;t=mod(atan(uv.y-.5,uv.x-.5)-r,6.28318)/6.28318;}vec3 color=u_c0;' + mix + 'gl_FragColor=vec4(color,1.);}';
        const sh = (t, s) => { const x = gl.createShader(t); gl.shaderSource(x, s); gl.compileShader(x); return x; };
        const prog = gl.createProgram(); gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(prog);
        const buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1]), gl.STATIC_DRAW);
        return { gl, prog };
    }

    gel('btnWebGL').addEventListener('click', () => {
        const [w, h] = dims(), btn = gel('btnWebGL'), s = sorted(), n = s.length;
        if (!glProg || glProg.n !== n) { const r = initGL(n); if (!r) { alert('WebGL not supported'); return; } glProg = { ...r, n }; }
        const { gl, prog } = glProg; glCvs.width = w; glCvs.height = h; gl.viewport(0, 0, w, h); gl.useProgram(prog);
        const a = gl.getAttribLocation(prog, 'a'); gl.enableVertexAttribArray(a); gl.vertexAttribPointer(a, 2, gl.FLOAT, false, 0, 0);
        gl.uniform2f(gl.getUniformLocation(prog, 'u_r'), w, h); gl.uniform1f(gl.getUniformLocation(prog, 'u_a'), S.angle);
        gl.uniform1i(gl.getUniformLocation(prog, 'u_t'), S.type === 'linear' ? 0 : S.type === 'radial' ? 1 : 2);
        s.forEach((x, i) => { const [r, g, b] = h2rgb(x.color); gl.uniform3f(gl.getUniformLocation(prog, `u_c${i}`), r, g, b); gl.uniform1f(gl.getUniformLocation(prog, `u_p${i}`), x.pos / 100); });
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        dl(glCvs.toDataURL('image/png'), `gradient-webgl-${w}x${h}.png`); fb(btn, '⬇ PNG WebGL');
    });

    // ── Toast ──────────────────────────────────────────────────
    function showToast(msg) {
        const t = gel('toast'); t.textContent = msg; t.classList.add('show');
        setTimeout(() => t.classList.remove('show'), 2000);
    }

    // ── Init ───────────────────────────────────────────────────
    syncControls();
    renderPalettes();
    S.stops.forEach((_, i) => colorsList.appendChild(buildColorRow(i)));
    renderHistory();
    renderFavorites();
    render(true);

}());